import _ from 'lodash';
import React from 'react';
import ReactDOM from 'react-dom';
import './SelectGroup.scss';
import axios from '../../lib/AxiosInstance';
import reducerStore from '../../reducers/reducerStore';

class SelectGroup extends React.Component {
	constructor(props) {
		super(props);

		this.state = {
			open: false,
			data: [],
			selected: [],
			searchString: '',
			result: [],
			yPos: 0
		};
	}

	componentDidMount() {
		this.getDataFromEndpoint();
		this.calculatePosition();
	}

	componentDidUpdate(prevProps) {
		if (prevProps.endpoint !== this.props.endpoint) {
			this.getDataFromEndpoint(prevProps.endpoint);
		}
	}

	getDataFromEndpoint(prevPropsEndpoint) {
		axios
			.get(`/api/${this.props.endpoint}`)
			.then(data => {
				const result = _.groupBy(data.data, entity => _.get(entity, this.props.group, 'noGroup'));
				let selectedItem;
				if (this.props.widget.widgetType === 'competition') {
					if (this.props.field === 'user') {
						selectedItem = _.get(this.props.widget.competitionSettings, this.props.field, []);
					} else if (this.props.field === 'selectedTypes' && this.props.widget.competitionSettings) {
						//if activty type was selected and then appointment is selected so update the state
						//so that the selectedItem reflects nothing selected kuz the type has been chagned
						if (prevPropsEndpoint && prevPropsEndpoint !== this.props.endpoint) {
							//reducerStore.dispatch({ type: 'UPDATE_COMPETITION_CRITERIA', property: this.props.field, value: [], index: this.props.index });
							this.props.setWidgetFieldValue(this.props.field, []);
							selectedItem = [];
						} else {
							selectedItem = _.get(this.props.criteria, this.props.field, []);
						}
					} else {
						selectedItem = [];
					}
				} else {
					selectedItem = _.get(this.props.widget, this.props.field, []);
				}

				this.setState({
					data: result,
					result,
					selected: _.filter(selectedItem, item => {
						for (const group of Object.values(result)) {
							for (const obj of group) {
								if (obj.id === item) {
									return true;
								}
							}
						}
						return false;
					})
				});
			})
			.catch(err => {
				const data = [{ id: -1 }];
				_.set(data[0], this.props.label, `Något gick fel ${_.get(err, 'response.data', err)}`);
				_.set(data[0], 'error', 'Error');

				const grouped = _.groupBy(data, entity => _.get(entity, 'error', 'noGroup'));

				this.setState({
					data: grouped,
					result: grouped
				});
			});
	}

	calculatePosition() {
		const rect = ReactDOM.findDOMNode(this).getBoundingClientRect();
		this.setState({ yPos: window.innerHeight / 2 - rect.top + rect.height / 2 > 0 ? 0 : -112 });
	}

	getListItem(result, padding = 0) {
		const classes = ['list-item'];
		if (_.includes(this.state.selected, result.id)) {
			classes.push('search-selected');
		}

		return (
			<li
				className={classes.join(' ')}
				onClick={() => {
					this.select(result.id);
				}}
				style={{ paddingLeft: padding }}
				key={result.id}
			>
				<div className="toggle">
					<i className="fa fa-check" />
				</div>
				{result[this.props.label]}
			</li>
		);
	}

	getListGroup(group, key) {
		const className = ['header'];
		const groupContents = [];

		_.each(group, r => groupContents.push(this.getListItem(r, '30px')));

		if (
			_.difference(
				_.map(this.state.data[key], entity => entity.id),
				this.state.selected
			).length === 0
		) {
			className.push('search-selected');
		}

		return (
			<li className={className.join(' ')} key={key}>
				<div className="toggle" onClick={() => this.selectGroup(key)}>
					<i className="fa fa-check" />
				</div>
				{`${key} (${this.state.data[key].length})`}
				<ul>{groupContents}</ul>
			</li>
		);
	}

	getSearchWindow() {
		const searchResults = [];

		if (this.state.result.noGroup) {
			_.each(this.state.result.noGroup, r => searchResults.push(this.getListItem(r)));
		}

		_.each(_.omit(this.state.result, 'noGroup'), (r, key) => searchResults.push(this.getListGroup(r, key)));

		return (
			<div
				ref={searchWindow => searchWindow && searchWindow.focus()}
				className="select-modal"
				style={{ transform: `translate(0%, ${this.state.yPos}%)` }}
			>
				<div className="title">{this.props.title}</div>
				<div className="search">
					<input
						type="text"
						value={this.state.searchString}
						onChange={event => this.filterResult(event.target.value)}
						className="form-control"
						placeholder="Sök"
						ref={search => search && search.focus()}
					/>
					{this.state.result.length > 1 ? (
						<div className="search-info">{`${this.state.result.length} träffar`}</div>
					) : null}
					{this.state.result.length === 1 ? (
						<div className="search-info">{`${this.state.result.length} träff`}</div>
					) : null}
				</div>
				<div className="select-content">
					<div className="filter-list">
						<ul className="results">
							<li
								className={!this.state.selected.length ? 'list-item search-selected' : 'list-item'}
								onClick={() => {
									this.selectAll();
								}}
							>
								<div className="toggle">
									<i className="fa fa-check" />
								</div>
								Välj samtliga
							</li>
							{searchResults}
						</ul>
					</div>
				</div>
				<div className="modal-footer">
					<div style={{ float: 'right' }}>
						{/*
                                FIX ME : should maybe have this cancel button?
                                right now this is just for the looks and easy close the window.
                        */}
						<button className="regular" onClick={() => this.setState({ open: false })}>
							Avbryt
						</button>
						<button className="blue" onClick={() => this.setState({ open: false })}>
							OK
						</button>
					</div>
				</div>
			</div>
		);
	}

	buildHeader() {
		if (!this.state.selected.length) {
			return this.props.placeholder; // 'Samtliga';
		} else if (this.state.selected.length === 1) {
			let entity;

			_.each(this.state.data, group => {
				if (entity) return;
				entity = _.find(group, item => item.id === this.state.selected[0]);
			});

			if (this.state.selected[0] === '') {
				return this.props.placeholder; // 'Samtliga';
			} else {
				return entity[this.props.label];
			}
		}
		let entity;

		_.each(this.state.data, group => {
			if (entity) return;
			entity = _.find(group, item => item.id === this.state.selected[0]);
		});

		return `${entity[this.props.label]} och ${this.state.selected.length - 1} till`;
	}

	filterResult(searchValue) {
		const result = {};

		_.each(this.state.data, (group, key) => {
			const filteredGroup = _.filter(group, member =>
				_.includes(member[this.props.label].toLowerCase(), searchValue.toLowerCase())
			);

			if (!filteredGroup.length && !_.includes(key.toLowerCase(), searchValue.toLowerCase())) return;

			result[key] = filteredGroup;
		});

		this.setState({
			searchString: searchValue,
			result
		});
	}

	selectAll() {
		this.setState({
			selected: []
		});

		this.props.setWidgetFieldValue(this.props.field, []);
		this.props.setWidgetFieldValue('dataConfig.include.type', 'all');
	}

	selectGroup(group) {
		let allIds;

		if (
			_.difference(
				_.map(this.state.data[group], entity => entity.id),
				this.state.selected
			).length === 0
		) {
			allIds = _.difference(
				this.state.selected,
				_.map(this.state.data[group], entity => entity.id)
			);
		} else {
			allIds = _.union(
				_.map(this.state.data[group], entity => entity.id),
				this.state.selected
			);
		}

		this.setState({
			selected: allIds
		});

		this.props.setWidgetFieldValue(this.props.field, allIds);
		this.props.setWidgetFieldValue('dataConfig.include.type', 'user');
	}

	select(item) {
		let selected = this.state.selected;

		if (!selected) {
			selected = [];
		}

		if (_.includes(selected, item)) {
			_.pull(selected, item);
		} else {
			selected.push(item);
		}

		this.setState({
			selected
		});

		this.props.setWidgetFieldValue(this.props.field, selected);
		this.props.setWidgetFieldValue('dataConfig.include.type', 'user');
	}

	render() {
		const header = this.buildHeader();
		return (
			<div className="select-group">
				<button className="input" onClick={() => this.setState({ open: !this.state.open })}>
					{header}
				</button>
				{this.state.open ? this.getSearchWindow() : null}
			</div>
		);
	}
}

SelectGroup.defaultProps = {
	placeholder: 'Samtliga'
};

SelectGroup.propTypes = {
	title: React.PropTypes.string.isRequired,
	label: React.PropTypes.string.isRequired,
	group: React.PropTypes.string,
	endpoint: React.PropTypes.string.isRequired,
	setWidgetFieldValue: React.PropTypes.func.isRequired,
	field: React.PropTypes.string.isRequired,
	widget: React.PropTypes.object.isRequired,
	placeholder: React.PropTypes.string.isRequired
};

export default SelectGroup;



/** WEBPACK FOOTER **
 ** ./client/components/SettingsModal/SelectGroup.jsx
 **/